import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import '../../settings.scss';
import { newObjectCreater } from '../../../../../utils/controller';
import { getCities, getIndustries, getStates } from '../../../../../services/vendor';
import ProfileForm from './components/profileForm';
import {
	getOrganizationProfile,
	updateProfileSettings,
} from '../../../../../services/settings/organization';
import PageLoader from '../../../../../component/PageLoader';
import SettingHeaderComponent from '../../components/settingHeaderComponent';
import { useDispatch } from 'react-redux';
import { fetchUserInfo } from '../../../../../store/action/userInfo';

export default function ProfileSettings({ activeTab }) {
	const dispatch = useDispatch();
	const [isOpenModal, setIsOpenModal] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [cityList, setCityList] = useState([]);
	const [stateList, setStatesList] = useState([]);
	const [industryList, setIndustrieList] = useState([]);
	const [languageList, setLanguageList] = useState([{ key: 'English', value: 'English' }]);
	const [fiscalYearList, setFiscalYearList] = useState([
		{ key: 'April-March', value: 'April-March' },
	]);
	const [dateFormatList, setDateFormatList] = useState([]);
	const [dateSeparatorList, setDateSeparatorList] = useState([
		{ key: '/', value: '/' },
		{ key: '-', value: '-' },
		{ key: '.', value: '.' },
	]);
	const [timeZoneList, setTimeZoneList] = useState([
		{ key: 'India(GMT+5:30)', value: 'India(GMT+5:30)' },
	]);
	const [primaryContact, setPrimaryContact] = useState({ name: '', email: '', phone_number: '' });
	const [primaryContactForm, setPrimaryContactForm] = useState({
		name: '',
		email: '',
		phone_number: '',
	});
	const [organisationProfile, setOrganisationProfile] = useState({});
	const [formData, setFormData] = useState({
		organisation_name: '',
		organisation_logo: null,
		industry_name: '',
		address: {
			street_1: '',
			street_2: '',
			state_id: '',
			city_id: '',
			postal_code: '',
			country_id: 1,
			phone_number: '',
		},
		domain: '',
		fiscal_year: '',
		language: '',
		time_zone: '',
		date_format: '',
		date_separator: '',
	});
	const [error, setError] = useState({});
	const handleFormData = (key, value, required = false) => {
		setFormData((prev) => ({
			...prev,
			[key]: value,
		}));
		let newError = { ...error };
		if (required) {
			if (key === 'industry_id') {
				if (value === '') {
					newError.industry_id = 'Please select a valid industry from the list.';
				} else {
					delete newError.industry_id;
				}
			}
			if (key === 'organisation_name') {
				if (value === '' || value === null) {
					newError.organisation_name = 'Please enter organization name in the field.';
				} else {
					delete newError.organisation_name;
				}
			}
			if (key === 'domain') {
				if (value === '' || value === null) {
					newError.domain = 'Please enter organization domain in the field.';
				} else {
					delete newError.domain;
				}
			}
		}
		setError(newError);
	};
	const handleAddressFormData = (key, value, required = false) => {
		setFormData((prev) => ({
			...prev,
			address: {
				...prev.address,
				[key]: value,
			},
		}));
		if (required) {
			var newError = { ...error };
			if (key === 'phone_number') {
				if (value) {
					if (value.length > 10 || value.length < 10) {
						newError.phone_number = `Please enter valid mobile number in the field`;
					} else {
						delete newError.phone_number;
					}
				} else {
					delete newError.phone_number;
				}
			}
			setError(newError);
		}
	};
	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}

	async function getOrganizationProfileDetail() {
		try {
			setLoading(true);
			const { organisation, address, primary_contact } = await getOrganizationProfile();
			var organisationDetails = {
				organisation_name: organisation?.organisation_name,
				organisation_logo:
					organisation?.organisation_logo !== undefined && organisation?.organisation_logo !== null
						? organisation?.organisation_logo
						: '',
				industry_id: organisation?.industry?.id || '',
				address: {
					street_1: address?.street_1 || '',
					street_2: address?.street_2 || '',
					state_id: address?.state?.id,
					city_id: address?.city?.id,
					postal_code: address?.postal_code,
					country_id: address?.country?.id,
					phone_number: organisation?.phone_number || '',
				},
				domain: organisation?.sub_domain || '',
				fiscal_year: organisation?.fiscal_year,
				language: organisation?.language,
				time_zone: organisation?.time_zone,
				date_format:
					organisation?.date_format !== undefined && organisation?.date_format !== null
						? organisation?.date_format
						: '',
				date_separator:
					organisation?.date_separator !== undefined && organisation?.date_separator !== null
						? organisation?.date_separator
						: '',
			};
			var contactDetail = {
				name: `${primary_contact?.first_name || ''} ${primary_contact?.last_name || ''}`,
				email: primary_contact?.email || '',
				phone_number: primary_contact?.phone_number || '',
			};
			setFormData(organisationDetails);
			setPrimaryContact(contactDetail);
			setOrganisationProfile(organisationDetails);
			setError({});
		} catch (err) {
			toast.error(err.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	}

	function checkValidation() {
		const newError = { ...error };
		if (
			!formData.industry_id ||
			formData.industry_id === '' ||
			formData.industry_id === undefined
		) {
			newError.industry_id = 'Please select a valid industry from the list.';
		} else {
			delete newError.industry_id;
		}
		if (
			!formData.organisation_name ||
			formData.organisation_name === '' ||
			formData.organisation_name === undefined
		) {
			newError.organisation_name = 'Please enter organisation name in the field';
		} else {
			delete newError.organisation_name;
		}
		if (
			!formData.domain ||
			formData.domain === '' ||
			formData.domain === undefined ||
			(formData.domain && newError.domain)
		) {
			newError.domain = newError.domain || 'Please enter organisation domain in the field';
		} else {
			delete newError.domain;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleOrganizationSave = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				'Something went wrong while update organisation Profile! Please fill required fields.',
			);
		} else {
			try {
				setLoader(true);
				setIsEdit(false);
				var body = {
					organisation_name: formData.organisation_name,
					organisation_logo: formData.organisation_logo || '',
					industry_id: formData?.industry_id,
					sub_domain: formData.domain,
					fiscal_year: formData.fiscal_year,
					language: formData.language,
					time_zone: formData.time_zone,
					date_format: formData.date_format,
					date_separator: formData.date_separator,
					address: formData?.address,
				};
				const res = await updateProfileSettings(body);
				if (res.success === true) {
					localStorage.setItem('suburl', formData.domain);
					toast.success(res.message);
					dispatch(fetchUserInfo());
				} else {
					setIsEdit(true);
					toast.error(res.message || 'Something went wrong');
				}
			} catch (error) {
				setIsEdit(true);
				toast.error(error.message || 'Something went wrong');
			} finally {
				setLoader(false);
			}
		}
	};

	const getStateList = async () => {
		try {
			const { states } = await getStates();
			var statesArray = newObjectCreater(states);
			setStatesList(statesArray);
		} catch (e) {
			toast.error(e.message || 'Something went wrong!');
		}
	};
	const getIndustryList = async () => {
		try {
			const { industries } = await getIndustries();
			var industryArray = newObjectCreater(industries);
			setIndustrieList(industryArray);
		} catch (e) {
			toast.error(e.message || 'Something went wrong!');
		}
	};

	const getDateFormatList = () => {
		try {
			var list = [];
			if (
				formData.date_format !== '' &&
				formData.date_format !== null &&
				formData.date_format !== undefined
			) {
				var value = '';
				if (formData.date_format.includes('/')) {
					value = formData.date_format.replaceAll('/', formData.date_separator);
				}
				if (formData.date_format.includes('-')) {
					value = formData.date_format.replaceAll('-', formData.date_separator);
				}
				if (formData.date_format.includes('.')) {
					value = formData.date_format.replaceAll('.', formData.date_separator);
				}
				handleFormData('date_format', value);
			}

			if (formData.date_separator === '-') {
				list = [
					{ key: 'dd-mm-yy [07-11-2025]', value: 'dd-mm-yy [07-11-25]', type: 'Short' },
					{ key: 'dd-mm-yyyy [07-11-2025]', value: 'dd-mm-yyyy [07-11-2025]', type: 'Medium' },
					{
						key: 'dd-mmmm-yyyy [07-11-2025]',
						value: 'dd-mmmm-yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			} else if (formData.date_separator === '.') {
				list = [
					{ key: 'dd.mm.yy [07.11.2025]', value: 'dd.mm.yy [07.11.25]', type: 'Short' },
					{ key: 'dd.mm.yyyy [07.11.2025]', value: 'dd.mm.yyyy [07.11.2025]', type: 'Medium' },
					{
						key: 'dd.mmmm.yyyy [07.11.2025]',
						value: 'dd.mmmm.yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			} else {
				list = [
					{ key: 'dd/mm/yy [07/11/2025]', value: 'dd/mm/yy [07/11/25]', type: 'Short' },
					{ key: 'dd/mm/yyyy [07/11/2025]', value: 'dd/mm/yyyy [07/11/2025]', type: 'Medium' },
					{
						key: 'dd/mmmm/yyyy [07/11/2025]',
						value: 'dd/mmmm/yyyy [07 November 2025]',
						type: 'Large',
					},
				];
			}

			setDateFormatList(list);
		} catch (e) {
			toast.error(e);
		}
	};

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(organisationProfile) !== JSON.stringify(formData);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		getShowUndoChanged();
	}, [formData]);

	useEffect(() => {
		getCity(formData.address.state_id);
	}, [formData.address.state_id]);

	useEffect(() => {
		getStateList();
	}, []);
	useEffect(() => {
		getIndustryList();
	}, []);

	useEffect(() => {
		getOrganizationProfileDetail();
	}, []);

	useEffect(() => {
		getDateFormatList();
	}, [formData.date_separator]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={[
					{
						id: 1,
						disabled: !isEdit || loader,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: loader,
						handler: () => {
							handleOrganizationSave();
						},
					},
					isEdit && {
						id: 1,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getOrganizationProfileDetail();
						},
					},
				].filter((button) => button !== false)}
			/>
			{isLoading ? (
				<PageLoader />
			) : (
				<ProfileForm
					formData={formData}
					primaryContact={primaryContact}
					primaryContactForm={primaryContactForm}
					setPrimaryContactForm={setPrimaryContactForm}
					setFormData={setFormData}
					error={error}
					setError={setError}
					isOpenModal={isOpenModal}
					setIsOpenModal={setIsOpenModal}
					cityList={cityList}
					languageList={languageList}
					fiscalYearList={fiscalYearList}
					dateFormatList={dateFormatList}
					dateSeparatorList={dateSeparatorList}
					timeZoneList={timeZoneList}
					stateList={stateList}
					industryList={industryList}
					handleFormData={handleFormData}
					handleAddressFormData={handleAddressFormData}
					getOrganizationProfileDetail={getOrganizationProfileDetail}
				/>
			)}
		</div>
	);
}
